import { render, staticRenderFns } from "./NewReleaseCommitButton.vue?vue&type=template&id=32f36917"
import script from "./NewReleaseCommitButton.vue?vue&type=script&lang=js"
export * from "./NewReleaseCommitButton.vue?vue&type=script&lang=js"
import style0 from "./NewReleaseCommitButton.vue?vue&type=style&index=0&id=32f36917&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports